import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { showLoader } from "../../redux/actions/action_loader";
import Snackbar from "../Snackbar/Snackbar";
import Button from "@material-ui/core/Button";
import { getApiData } from "../../api/api";
import { getDevice, isIOSDevice } from "../../utils/getDevice";
import "./SelfieOld.css";
import {
  compress,
  getBase64TypeAndString,
  compressImage,
} from "../../utils/compressor";
import { messages } from "../../utils/disclaimerText";
import Modal from "react-modal";
import { generateCorrelationId } from "../../utils/correlationId";
import { withTranslation } from "react-i18next";
import CircularProgressWithLabel from "../Loader/circularLoaderWithLabel";
import SelfieInfoScreen from "./InfoScreen/InfoScreen";
import SelfieStepper from "./Stepper/SelfieStepper";
import { cross, done } from "../../images/images";
import { CircularProgress } from "@material-ui/core";
import GradientLoader from "../Loader/GradientLoader";
import { faceMeshPrediction } from "../../utils/facemeshData";
import AllowAccess from "./AllowAccess/AllowAccess";
import HeadStepper from '../HeadStepper/HeadStepper';
import { QCSteps, hybridPosvSteps, isNpsSteps, photoVerificationSteps } from "../../utils/stepperStep";

import { playVoiceOver, stopAudio } from "../../utils/handleVoiceAndLang";

import AxiosRequest from "../../utils/axios";

const axios = new AxiosRequest().getClient()
class SelfieOld extends Component {
  trackerTask;
  videoWithoutTracking;
  gettingFace;
  tensorFlowFaceDetction;
  normalSelfieInterval;
  model;

  constructor(props) {
    super(props);
    this.state = {
      aiSelfieCapturing: false,
      aiSelfieProgress: 0,
      aiImageCaptured: false,
      video: undefined,
      pictureTaken: false,
      retakeMode: false,
      submitting: false,
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
      loadingVideo: undefined,
      boothWidth: "240px",
      boothHeight: "240px",
      gotEvent: false,
      channelName: "",
      mediaSupport:
        navigator &&
        navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia &&
        !isIOSDevice(),
      errCount: 0,
      isModal: false,
      locationAccess: "",
      faceDectected: undefined,
      faceDetectionProgress: 0,
      showInfoPage: true,
      lat: null,
      long: null,
      showTakeSelfieButton: false,
      selfieErrorMsg: "",
      takeSelfieCount: 1,
      statusCode: "",
      selfieRequestSend: false,
      showSubmitSelfieButton:
        localStorage.getItem("category") == "selfie" ? true : false,
      showAllowAccess: false,
      proposerFirstname: localStorage.getItem('proposerFirstname'),
      isNps: localStorage.getItem('isNps'),
      isVideoPosv: localStorage.getItem('isVideoPosv'),
      simplifiedJourney: localStorage.getItem('simplifiedJourney'),
      twoStep: localStorage.getItem('twoStep')
    };

    props.history.listen((action) => {
      if (action === "POP") {
        this.props.history.push("/selfie");
        this.props.showLoader(false);
      }
    });
  }

  componentDidMount() {
    console.log('OLD PAGE')
    this.loadFacemeshModel();
    window.scrollTo(0, 0);
    let channelName = localStorage.getItem("channelName");
    let category = localStorage.getItem("category");
    const { isVideoPosv } = this.state
    if (isVideoPosv === "Y") {
      playVoiceOver('selfie-aud', "selfie")
    }
    if (category == "selfie") {
      this.checkLocationPermission();
      this.setState(
        { loadingVideo: true, showInfoPage: false, showSelfieButtons: true },
        () => {
          this.initializeVideo();
        }
      );
    }
    this.setState({ channelName: channelName, category: category });
  }
  loadFacemeshModel = async () => {
    try {
      this.model = await window.facemesh.load();
    } catch (err) {
      console.log('old page load model err : ', err)
      this.setState({ fdModelLoadErr: true})
    }
  };
  initializeVideo = () => {
    this.startVideoWithTensensorFlow();
  };

  checkLocationPermission = async () => {
    const permissionStatus = await navigator?.permissions?.query({
      name: "geolocation",
    });
    const hasPermission = permissionStatus?.state;
    this.getLocation();
    this.setState({ locationAccess: hasPermission });
    return hasPermission;
  };


  checkCamera = async () => {
    const permissionStatus = await navigator?.permissions?.query({
      name: "camera",
    });

    this.setState({ permissionStatus: permissionStatus.state })

  }

  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    }
  };

  showPosition = (position) => {
    this.setState({
      lat: position.coords.latitude,
      long: position.coords.longitude,
    });
  };

  captureImages = () => {
    this.setState({
      showTakeSelfieButton: false,
      showSubmitSelfieButton: false,
    });
    let video = document.getElementById("video");
    let canvas = document.getElementById("canvas");
    canvas.width = 240;
    canvas.height = 240;

    if (this.state.category === "selfie") {
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      let imageCaptured = canvas.toDataURL("image/jpeg", 1.0);
      this.takephoto(imageCaptured);
      this.closeWebcam();
      this.setState({
        pictureTaken: true,
        picture: imageCaptured,
        showTakeSelfieButton: true,
        showSubmitSelfieButton: true,
      });
    }
    if (this.state.category === "selfie_live") {
      this.setState({ aiSelfieCapturing: true, aiImageCaptured: false });
      let progress = 30;
      let imageType = "";
      let imageArr = [];
      let selfiesInterval = setInterval(async () => {
        if (!this.gettingFace) {
          this.handleSnackbar(
            true,
            "error",
            this.props.t("selfie live err msg on exit frame")
          );
          clearInterval(selfiesInterval);
          this.setState({
            pictureTaken: false,
            aiSelfieCapturing: false,
            aiSelfieProgress: 0,
            showTakeSelfieButton: true,
          });
          this.initializeVideo();
          return;
        }
        if (imageArr.length == 10) {
          clearInterval(selfiesInterval);
          clearInterval(this.tensorFlowFaceDetction);
          this.startVideoWithoutTracking();
          this.setState({ pictureTaken: true, showSelfieButtons: true });
          this.sendAiSelfieRequest(imageArr, imageType);
          return;
        }
        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height);
        let image = canvas.toDataURL("image/jpeg", 1.0);
        await compress(image)
          .then(async (res) => {
            progress += 5.5;
            let { byteArray } = res;
            let { type, imgString } = getBase64TypeAndString(byteArray);

            imageArr.push(imgString);
            imageType = type;
            this.setState({ aiSelfieProgress: progress });
          })
          .catch((err) => { });
      }, 400);
    }
  };

  sendAiSelfieRequest = async (imageArray, imageType) => {
    this.setState({ selfieRequestSend: true })
    let { url, body } = getApiData("validateCustomerSelfie");
    body.request.header.correlationId = generateCorrelationId();
    body.request.payload.planCode = localStorage.getItem("planCode");
    body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");
    body.request.payload.multipleImageFile = imageArray;
    body.request.payload.sessionId = localStorage.getItem("sessionId");
    body.request.payload.sourceId = localStorage.getItem("source");
    body.request.payload.eventType = "click";
    body.request.payload.journeyBy = localStorage.getItem("journeyBy");

    body.request.payload.fileExtension = imageType;
    body.request.payload.iosStatus = isIOSDevice() ? true : false;
    body.request.payload.authToken = "";
    body.request.payload.takeSelfieCount = this.state.takeSelfieCount;


    try {
      const response = await axios.post(url, body);
      const byteselfiarray = response.data.response.payload.selfieByteArray;
      let statusCode = response.data.response.msgInfo.msgCode;

      let imageFromApi =
        byteselfiarray && byteselfiarray.length
          ? byteselfiarray
          : imageArray[0];
      this.setState({ statusCode });

      if (statusCode == 200) {
        this.takephoto(`data:image/${imageType};base64,` + imageFromApi);
        this.closeWebcam();
        this.handleSnackbar(
          true,
          "success",
          response.data.response.payload.businessMsg
        );
        this.setState({
          aiImage: imageFromApi,
          aiImgArray: imageArray,
          aiImageType: imageType,
          aiImageCaptured: true,
          showSubmitSelfieButton: true,
          showTakeSelfieButton: true,
        });
      } else if (statusCode == 400) {
        this.takephoto(`data:image/${imageType};base64,` + imageFromApi);
        this.closeWebcam();
        this.setState({
          showSubmitSelfieButton: true,
          showTakeSelfieButton: false,
          aiImageCaptured: true,
          aiImage: imageFromApi,
        });
      } else {
        this.takephoto(`data:image/${imageType};base64,` + imageFromApi);
        this.closeWebcam();
        this.handleSnackbar(
          true,
          "error",
          response.data.response
            ? response.data.response.payload.businessMsg
            : "Time out."
        );
        this.setState({
          aiImageCaptured: true,
          showTakeSelfieButton: true,
        });
      }
    } catch (err) {
      this.handleSnackbar(
        true,
        "error",
        "We were not able to capture the best picture. Please re-take picture."
      );
      this.handleErrorScenarios();
      this.setState({ errCount: 0, showTakeSelfieButton: true });
      this.gettingFace = undefined;
    } finally {
      this.setState({
        aiSelfieCapturing: false,
        pictureTaken: true,
        aiSelfieProgress: 0,
        faceDetectionProgress: 0,
        takeSelfieCount: this.state.takeSelfieCount + 1,
        selfieRequestSend: false
      });
    }
  };

  handleBoothClick = () => {
    if (!this.state.mediaSupport) {
      this.takeSelfie();
    }
  };

  startVideoWithoutTracking = () => {
    let canvas = document.getElementById("canvas");
    let video = document.getElementById("video");
    this.videoWithoutTracking = setInterval(() => {
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
    }, 40);
  };

  startVideoWithTensensorFlow = async () => {
    const { category, isVideoPosv } = this.state;
    let audioRequired = isVideoPosv === "Y" ? true : false
    let height = "240px";
    let width = "240px";

    const canvas = document.getElementById("canvas");
    canvas.style.visibility = "visible";
    canvas.style.borderRadius = "100%";

    this.setState({ loadingVideo: true });
    let img = document.getElementById("img");
    if (img) {
      img.parentNode.removeChild(img);
    }
    const video = document.getElementById("video");
    video.style.visibility = "hidden";
    video.style.display = "block";
    video.style.borderRadius = "100%";
    video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    navigator.mediaDevices
      .getUserMedia({
        video: { width: 240, height: 240, facingMode: "user" },
        audio: audioRequired,
      })
      .then((stream) => {
        this.setState({ showAllowAccess: false })
        video.srcObject = stream;

      })
      .catch(function (error) {
        this.setState({ openModal: true })
        if (this.state.permissionStatus !== 'granted') {
          this.setState({ showAllowAccess: true })
        }
      }.bind(this))


    video.addEventListener("loadeddata", async () => {
      if (category == "selfie_live") {
        clearInterval(this.videoWithoutTracking);
        this.tensorFlowFaceDetction = setInterval(async () => {
          const prediction = await this.model.estimateFaces(video, false);

          this.detectFaces(prediction);
        }, 40);
      } else {
        this.setState({ showTakeSelfieButton: true })
        this.normalSelfieInterval = setInterval(() => {
          canvas.width = 240;
          canvas.height = 240;
          canvas.style.display = "block";
          canvas.style.visibility = "visible";
          const context = canvas.getContext("2d");
          context.translate(canvas.width, 0);
          context.scale(-1, 1);
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
        }, 40);
      }
    });

    video.addEventListener(
      "canplay",
      function (ev) {
        video.setAttribute("height", height);
        video.setAttribute("width", width);
      },
      false
    );
  };

  detectFaces = (prediction) => {
    const { pictureTaken, category, aiImageCaptured } = this.state;
    if (pictureTaken) return;
    const video = document.getElementById("video");
    const canvas = document.getElementById("canvas");
    canvas.width = 240;
    canvas.height = 240;
    canvas.style.display = "block";
    if (category == "selfie_live") {
      if (aiImageCaptured) {
        canvas.style.visibility = "hidden";
      } else {
        canvas.style.visibility = "visible";
      }
    } else {
      canvas.style.visibility = "visible";
    }
    const context = canvas.getContext("2d");
    context.translate(canvas.width, 0);
    context.scale(-1, 1);
    context.fillStyle = "rgba(255,255,255,0.8)"

    context.drawImage(video, 0, 0, video.width, video.height, 0, 0, canvas.width, canvas.height);
    faceMeshPrediction.forEach(p => {
      const keypoints = p.scaledMesh;
      for (let i = 0; i < keypoints.length; i++) {
        const x = keypoints[i][0];
        const y = keypoints[i][1];
        context.beginPath();
        context.arc(x, y, 1.5, 0.5, 2 * Math.PI);
        context.fill();
      }
    });

    if (prediction.length == 1) {
      this.gettingFace = true;
      this.setState({
        faceDectected: true,
        faceDetectionProgress: 30,
        showSelfieButtons: false,
      });
      prediction.forEach((pred) => {
        if (
          category == "selfie_live" &&
          pred.boundingBox.bottomRight[0] - pred.boundingBox.topLeft[0] < 130
        ) {
          this.gettingFace = false;
          if (category == "selfie_live") {
            this.setState({ showSelfieButtons: false, showTakeSelfieButton: false });
          }
          this.setState({
            faceDectected: false,
            faceDetectionProgress: 0,
            selfieErrorMsg: "selfie live err msg",
          });
        } else if (
          (category == "selfie_live" && pred.boundingBox.topLeft[0] < -20) ||
          pred.boundingBox.bottomRight[0] > 260 ||
          pred.boundingBox.topLeft[1] < 0 ||
          pred.boundingBox.bottomRight[1] > 268
        ) {
          this.gettingFace = false;
          if (category == "selfie_live") {
            this.setState({ showSelfieButtons: true, showTakeSelfieButton: false });
          }
          this.setState({
            faceDectected: false,
            faceDetectionProgress: 0,
            selfieErrorMsg: "selfie live err msg on exit frame",
          });
        } else if (prediction[0].faceInViewConfidence < 1) {
          this.gettingFace = false;
          if (category == "selfie_live") {
            this.setState({ showSelfieButtons: true, showTakeSelfieButton: false });
          }
          this.setState({
            faceDectected: false,
            faceDetectionProgress: 0,
            selfieErrorMsg: "selfie live err msg on covered face",
          });
        } else {
          this.setState({ showTakeSelfieButton: true })
          if (pred.boundingBox.topLeft[0] < 10 ||
            pred.boundingBox.bottomRight[0] > 230 ||
            pred.boundingBox.topLeft[1] < 10 ||
            pred.boundingBox.bottomRight[1] > 250) {



          }
        }
      });
    } else {
      this.gettingFace = false;
      if (category == "selfie_live") {
        this.setState({ showSelfieButtons: false });
      }
      this.setState({ faceDectected: false, faceDetectionProgress: 0 });
    }
  };

  takeSelfie = async () => {
    this.closeSnackbar();
    stopAudio('selfie-aud')
    const { category } = this.state;

    if (this.state.pictureTaken) {
      if (category == "selfie_live") {
        this.setState({ showSubmitSelfieButton: false });
      }
      if (this.state.mediaSupport) {
        this.setState({ pictureTaken: false, aiImageCaptured: false });
        const img = document.getElementById("img");
        if (img) {
          img.parentNode.removeChild(img);
        }
        this.initializeVideo();
      } else {
        this.setState({
          pictureTaken: false,
          aiImageCaptured: false,
          takeSelfieCount: this.takeSelfieCount + 1,
        });
        this.initializeVideo();
      }
      return;
    }

    if (!this.state.mediaSupport) {
      this.captureImages();
      return;
    }
    if (this.state.category === "selfie_live") {
      this.captureImages();
    }
    if (this.state.category === "selfie") {
      if (isIOSDevice()) {
        this.captureImages();
      } else {
        let video = document.getElementById("video");
        let canvas = document.getElementById("canvas");
        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height);
        let imageCaptured = canvas.toDataURL("image/jpeg", 1.0);
        this.takephoto(imageCaptured);
        this.setState({
          pictureTaken: true,
          picture: imageCaptured,
          showSubmitSelfieButton: true,
          showTakeSelfieButton: true,
        });
        this.closeWebcam();
      }

      this.captureImages();
    }
  };

  takephoto = (imgSrc) => {
    const video = document.getElementById("video");
    const canvas = document.getElementById("canvas");
    canvas.style.visibility = "hidden";
    video.style.display = "none";
    const img = new Image();
    img.setAttribute("id", "img");
    img.src = imgSrc;
    const booth = document.getElementById("booth");
    img.onload = () => {
      if (getDevice() === "mobile") {
        booth.style.width = img.width;
        booth.style.height = img.height;
        booth.style.border = "8px solid white";
      }
      booth.append(img);
    };
  };

  submitSelfie = async () => {
    this.props.showLoader(true);
    await this.setState({ submitting: true });

    if (this.state.category === "selfie_live") {
      this.sumbitPostRequest(this.state.aiImage, this.state.aiImageType);
    }

    if (this.state.category === "selfie") {
      const base64 = this.state.phonePicture
        ? this.state.phonePicture
        : this.state.picture;

      compress(base64)
        .then((result) => {
          let { byteArray } = result;
          let { type, imgString } = getBase64TypeAndString(byteArray);
          this.sumbitPostRequest(imgString, type);
        })
        .catch((err) => {
          let errCount = this.state.errCount;
          if (errCount < 1) {
            this.handleErrorScenarios();
            this.handleSnackbar(
              true,
              "error",
              errCount < 1
                ? messages.selfieCompressErrorFirst
                : messages.selfieCompressErrorSecond
            );
            errCount++;
            this.setState({ errCount });
          } else {
            this.setState({ isModal: true });
            this.props.showLoader(false);
          }
        });
    }
  };

  handleErrorScenarios = () => {
    this.props.showLoader(false);
    this.gettingFace = true;
    this.setState({ submitting: false });
    setTimeout(() => {
      console.log('media support : ',this.state.mediaSupport)
      // if (this.state.mediaSupport) {
        const img = document.getElementById("img");
        if (img) {
          img.parentNode.removeChild(img);
        }
        this.setState({ pictureTaken: false, showTakeSelfieButton: true, aiImageCaptured: false, showSubmitSelfieButton: false });
        this.initializeVideo();
      // }
    }, 2500);
    return;
  };

  sumbitPostRequest = async (imgString = "", type = "") => {
    const { isVideoPosv, simplifiedJourney } = this.state
    if (!imgString) {
      this.setState({ errCount: 0 });
      if (isVideoPosv === "Y") {
        this.props.history.push(`/video-verification?page=Product`);
      } else {
        this.props.history.push(`/customer_feedback?page=Product`);
      }
    } else if (this.state.category === "selfie") {
      const { url, body } = getApiData("verifyCustomerImage");
      body.request.payload.imageFile = imgString;
      body.request.payload.fileExtension = type;
      body.request.payload.iosStatus = isIOSDevice().toString();
      body.request.payload.faceDetected = false;
      if (simplifiedJourney == 'y') {
        body.request.payload.simplifiedJourney = simplifiedJourney;
      } else {
        body.request.payload.simplifiedJourney = "n";
      }

      this.postImageHandler(url, body);
    } else {
      const { lat, long } = this.state;
      let { url, body } = getApiData("validateCustomerSelfie");
      body.request.header.correlationId = generateCorrelationId();
      body.request.payload.planCode = localStorage.getItem("planCode");
      body.request.payload.posvRefNumber =
        localStorage.getItem("posvRefNumber");
      body.request.payload.multipleImageFile = [imgString];
      body.request.payload.eventType = "submit";
      body.request.payload.journeyBy = localStorage.getItem("journeyBy");

      body.request.payload.fileExtension = type;
      body.request.payload.iosStatus = isIOSDevice() ? true : false;
      body.request.payload.lat = lat;
      body.request.payload.longitude = long;
      body.request.payload.selfieTimestamp = Date.now();
      body.request.payload.faceDetected = true;
      if (simplifiedJourney == 'y') {
        body.request.payload.simplifiedJourney = simplifiedJourney;
      } else {
        body.request.payload.simplifiedJourney = "n";
      }
      this.postImageHandler(url, body);
    }
  };
  postImageHandler = async (url, body) => {
    const { isVideoPosv, simplifiedJourney } = this.state
    try {
      const response = await axios.post(url, body);

      if (
        response.data &&
        response.data.response &&
        !response.data.response.payload.isImageValid
      ) {
        this.handleSnackbar(
          true,
          "error",
          response.data.response.payload.businessMsg
        );
        this.handleErrorScenarios();
      } else {
        const path = response.data.response.payload.qstCatName.toLowerCase();
        if (!path) {
          this.props.history.push("/generate_otp");
          return;
        }
        localStorage.setItem("path", path);
        this.setState({ errCount: 0 });
        if (simplifiedJourney?.toLocaleLowerCase() == 'y') {
          if (isVideoPosv === "Y") {
            this.props.history.push(`/video-verification`);
          } else {
            this.props.history.push(`/customer_feedback`);
          }
        }
        else {
          if (isVideoPosv === "Y") {
            this.props.history.push(`/video-verification?page=${path}`);
          } else {
            this.props.history.push(`/customer_feedback?page=${path}`);
          }
        }

      }
    } catch (err) {
      this.handleSnackbar(
        true,
        "error",
        "Something went wrong. Please try again."
      );
      this.handleErrorScenarios();
      this.setState({ errCount: 0 });
    }
  };

  componentWillUnmount() {
    if (this.state.mediaSupport) {
      this.closeWebcam();
    }
  }

  closeWebcam = () => {
    const video = document.getElementById("video");
    setTimeout(function () {
      window.Webcam.reset();
      if (video && video.srcObject) {
        video.pause();
        video.srcObject.getVideoTracks()[0].stop();
      }
    }, 100);
  };

  handleSnackbar = (showSnackbar, snackbarMsgType, snackbarMsg) => {
    this.setState({ showSnackbar, snackbarMsgType, snackbarMsg });
    setTimeout(() => {
      this.closeSnackbar();
    }, 3000);
  };


  getSteps = () => {
    if (this.state.isNps == 'Y' || this.state.journeyBy == 'P') {
      return isNpsSteps
    } else if (this.state.isVideoPosv == 'Y') {
      return hybridPosvSteps
    } else if (this.state.twoStep == 'Y') {
      return QCSteps
    }
    else {
      return photoVerificationSteps
    }
  }



  closeSnackbar = () => {
    this.setState({
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
    });
  };

  handleNextButton = () => {
    const { fdModelLoadErr } = this.state
    const category = fdModelLoadErr ? "selfie" : "selfie_live";
    window.scrollTo(0, 0);
    this.checkLocationPermission();
    this.checkCamera()
    this.setState({ loadingVideo: true, showInfoPage: false, category }, () => {
      this.initializeVideo();
    });
  };

  getHtml = () => {
    const imgStyles = { width: "240", height: "240" };
    return (
      <>
        <video
          id="video"
          width="240"
          height="240"
          style={imgStyles}
          preload={"auto"}
          autoPlay
          loop
          muted
        ></video>
        <canvas id="canvas" width="240"
          height="240"></canvas>
      </>
    );
  };
  closeModal = () => {
    this.setState({ isModal: false });
    this.props.showLoader(true);
    this.sumbitPostRequest();
  };
  showModal = () => {
    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        maxWidth: "300px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    return (
      <Modal
        isOpen={this.state.isModal}
        onRequestClose={this.closeModal}
        style={customStyles}
        contentLabel="Warning"
      >
        <div>
          <p>{messages.selfieCompressErrorSecond}</p>
          <div className="btn-cstm">
            <button onClick={this.closeModal}>Ok</button>
          </div>
        </div>
      </Modal>
    );
  };

  render() {
    const buttonText = !this.state.pictureTaken
      ? "Take Selfie"
      : "Retake Selfie";
    const boothStyles = {
      width: this.state.boothWidth,
      height: this.state.boothHeight,
    };
    const customStyles2 = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        maxWidth: "300px",
        marginRight: "-50%",
        transform: "translate(-50%, -45%)",
      }
    };
    const {
      showSubmitSelfieButton,
      showTakeSelfieButton,
      showInfoPage,
      aiSelfieProgress,
      faceDetectionProgress,
      category,
      aiImageCaptured,
      statusCode,
      selfieRequestSend,
      aiSelfieCapturing,
      isVideoPosv
    } = this.state;

    return (
      <>
        <audio className="aud-el-hide" id='selfie-aud' ></audio>
        {showInfoPage ? (
          <SelfieInfoScreen handleNextButton={this.handleNextButton} />
        ) : (

          <div>
            <div className="headStepper">
              {
                !this.state.showAllowAccess && <HeadStepper activeState={0} allSteps={this.getSteps()} />
              }

            </div>


            <>
              <Modal
                isOpen={this.state.openModal}
                style={customStyles2}
                contentLabel="Warning"
              >
                <div>
                  {this.state.showAllowAccess ? <AllowAccess /> : <h3> Unable to stream video.</h3>}
                </div>
              </Modal>


              <div
                className="disclaimer"
                style={{
                  visibility: this.state.loadingVideo ? "hidden" : "visible",
                  display: this.state.channelName === "by" ? "flex" : "none",
                }}
              >
                <p>
                  The photograph submitted by you will be used as your photograph
                  on the insurance proposal form towards issuance and servicing of
                  this Axis Max life insurance policy and the same will not be used for
                  any other purpose.
                </p>
              </div>
              {this.state.showSnackbar ? (
                <Snackbar
                  closeSnackbar={this.closeSnackbar}
                  snackbarMsgType={this.state.snackbarMsgType}
                  snackbarMsg={this.props.t(`${this.state.snackbarMsg}`)}
                />
              ) : null}


              <div className={`selfie_page ${this.state.aiImageCaptured ? "picture_taken" : "not_taken"}`} id="selfie_page">
                <div className={!aiImageCaptured ? "selfie-btn-outer-cntnr" : "selfie-image"}
                  style={{
                    display: aiImageCaptured == false ? "block" : "none",
                  }}>
                  <div className="selfie-proposer-name"><h3>Dear {this.state.proposerFirstname},</h3></div>
                  {this.state.category === "selfie" ? (
                    <p
                      className="bold-msg selfie-page-image"
                      dangerouslySetInnerHTML={{
                        __html: this.props.t("In frame message"),
                      }}
                    ></p>
                  ) : null}
                  {this.state.aiImageCaptured === false &&
                    category === "selfie_live" && (
                      <>
                        {selfieRequestSend == true ? <div>
                          <p
                            className="bold-msg"
                            dangerouslySetInnerHTML={{
                              __html: this.props.t("Please wait while we are processing your Selfie, it’ll take 3-5 Seconds."),
                            }}
                          ></p>
                          <p
                            className="bold-msg"
                            dangerouslySetInnerHTML={{
                              __html: this.props.t("You can move away from camera now."),
                            }}
                          ></p>
                        </div>
                          :
                          <><p
                            className="bold-msg"
                            dangerouslySetInnerHTML={{
                              __html: this.props.t("Facemesh msg"),
                            }}
                          ></p>
                            <p
                              className={`small-msg-font ${aiSelfieCapturing ? '' : 'pulse-grow'} `}
                              dangerouslySetInnerHTML={{
                                __html: this.props.t(
                                  "Please smile a bit"
                                ),
                              }}
                            ></p>
                          </>
                        }

                      </>
                    )}
                </div>


                <div className="booth-hole">
                  <div
                    className="booth"
                    style={boothStyles}
                    id="booth"
                    onClick={this.handleBoothClick}
                  >
                    {this.getHtml()}
                  </div>

                  <div
                    className="display_text"
                    style={{
                      visibility: this.state.loadingVideo ? "visible" : "hidden",
                    }}
                  >
                    {!aiImageCaptured && <div>
                      <div className="loading">
                        <small>{this.props.t('Please wait while we setup camera for you')}</small>
                      </div>
                      <CircularProgress />
                    </div>}
                    {statusCode == 400 && <p>Liveness Not Detected</p>}
                  </div>

                  <GradientLoader
                    positionClass={"booth-border"}
                    aiSelfieProgress={
                      aiSelfieProgress ? aiSelfieProgress : faceDetectionProgress
                    }
                  />
                </div>

                {this.state.aiImageCaptured === false &&
                  this.state.category === "selfie_live" && (
                    <>
                      {this.gettingFace == false ? (
                        <small className="err-msg">
                          {this.props.t(this.state.selfieErrorMsg)}
                        </small>
                      ) : null}
                      <div>

                        {aiSelfieProgress == 95 && (
                          <p>{this.props.t("Please wait...")}</p>
                        )}
                        {this.gettingFace == false ? (
                          <div className="selfie-msg-cntnr">
                            <p className="err-msg">
                              {this.props.t("Face Detection")}
                            </p>
                            <img src={cross} height="15px" width="15px" alt="" />
                          </div>
                        ) : null}

                        {this.gettingFace == true && aiSelfieProgress < 95 && this.state.selfieRequestSend == false ? (
                          <div className="selfie-msg-cntnr">
                            <p className="success-msg">
                              {this.props.t("Face Detection")}
                            </p>
                            <img src={done} height="15px" width="15px" />
                          </div>
                        ) : null}
                        {this.state.selfieRequestSend == true ? (
                          <>
                            <div className="selfie-msg-cntnr">
                              <p className="success-msg">
                                {this.props.t("Face Detection")}
                              </p>
                              <img src={done} height="15px" width="15px" />
                            </div>
                            <div className="selfie-msg-cntnr">
                              <p className="success-msg">
                                {this.props.t("Liveliness Detection")}
                              </p>
                              <CircularProgress style={{ 'color': 'gray' }} size={15} />
                            </div>
                          </>) : null}
                      </div>
                    </>
                  )}
                {this.state.statusCode == 200 &&
                  this.state.aiImageCaptured === true &&
                  this.state.pictureTaken === true && (
                    <div className="stepper-msgs">
                      <div className="selfie-msg-cntnr">
                        <p className="success-msg">
                          {this.props.t("Face Detection")}
                        </p>
                        <img src={done} height="15px" width="15px" />
                      </div>

                      <div className="selfie-msg-cntnr">
                        <p className="success-msg">
                          {this.props.t("Liveliness Detection")}
                        </p>
                        <img src={done} height="15px" width="15px" />
                      </div>
                      <SelfieStepper orientation="vertical" currentStep="1" hybridPosv={isVideoPosv} />
                    </div>
                  )}
                {this.state.statusCode != 200 &&
                  this.state.aiImageCaptured === true &&
                  this.state.pictureTaken === true && (
                    <div className="stepper-msgs">
                      {statusCode != 400 && (
                        <div className="selfie-msg-cntnr">
                          <p className="success-msg">
                            {this.props.t("Face Detection")}
                          </p>
                          <img src={done} height="15px" width="15px" />
                        </div>
                      )}

                      <div className="selfie-msg-cntnr">
                        <p className="err-msg">
                          {this.props.t("Liveliness Detection")}
                        </p>
                        <img src={cross} height="15px" width="15px" />
                      </div>
                      <SelfieStepper orientation="vertical" currentStep="1" hybridPosv={isVideoPosv} />
                    </div>
                  )}

                <div
                  className={`selfie-btn-cntnr ${localStorage.getItem("LanguageSelected") == "hin"
                    ? "cntnr-width-90"
                    : "cntnr-width-65"
                    }`}
                >
                  <Button
                    disabled={
                      this.state.submitting ||
                      this.state.aiSelfieCapturing === true ||
                      !showTakeSelfieButton
                    }
                    onClick={(event) => this.takeSelfie(event)}
                    variant="contained"
                    id="selfie_button"
                    className="default_button"
                  >
                    {this.props.t(`${buttonText}`)}
                  </Button>
                  {showSubmitSelfieButton ? (
                    <Button
                      disabled={
                        this.state.submitting ||
                        !this.state.pictureTaken ||
                        this.state.aiSelfieCapturing === true
                      }
                      onClick={this.submitSelfie}
                      variant="contained"
                      className="default_button"
                    >
                      {this.props.t("Submit")}
                    </Button>
                  ) : null}
                </div>
              </div>
              {this.showModal()}
            </>

          </div>
        )
        }
      </>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showLoader }),
  withTranslation()
)(SelfieOld);
